import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-right",
  "use": "icon-caret-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-caret-right\"><path d=\"M16.777 11.567L7.852 3.87c-.333-.286-.82-.028-.82.433v15.394c0 .462.487.72.82.434l8.925-7.697a.587.587 0 000-.867z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol